export function SearchClearButton({ onClear }: { onClear: () => void }) {
  return (
    <button
      type="button"
      className="search-clear"
      aria-label="Clear search"
      tabIndex={-1}
      onMouseDown={(event) => event.preventDefault()}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onClear();
      }}
    >
      <svg width="8" height="8" viewBox="0 0 14 14" aria-hidden="true">
        <path
          d="M2 2l10 10M12 2L2 12"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}

export function SearchTile({
  value,
  onChange,
  hintId,
  hintLabel,
  fields,
  pending = false,
  placeholder = "Search ...",
  autoCloseHintOnInput = false,
}: {
  value: string;
  onChange: (value: string) => void;
  hintId: string;
  hintLabel: string;
  fields: string[];
  pending?: boolean;
  placeholder?: string;
  autoCloseHintOnInput?: boolean;
}) {
  const hideHint = autoCloseHintOnInput && value.length > 0;

  return (
    <div className="search-tile" data-pending={pending ? "true" : undefined}>
      <input
        className="search-tile-input"
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-describedby={hintId}
        aria-busy={pending || undefined}
      />
      {value ? <SearchClearButton onClear={() => onChange("")} /> : null}
      <span className="visually-hidden" id={hintId}>
        {hintLabel}
      </span>
      {!hideHint ? (
        <div className="search-tile-hint" role="tooltip">
          <span className="search-tile-hint-label">Searches</span>
          {fields.map((field) => (
            <span key={field}>{field}</span>
          ))}
        </div>
      ) : null}
    </div>
  );
}
